import { ToastrService } from 'ngx-toastr';
import { debounceTime, map } from 'rxjs/operators';
import { ProductService } from '@app/api/api';
import { DocumentService } from './../../../../../../../api/document.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'meu-app-modal-list-product-konva',
  templateUrl: './app-modal-list-product-konva.component.html',
  styleUrls: ['./app-modal-list-product-konva.component.scss']
})
export class AppModalListProductKonvaComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public ref: ChangeDetectorRef,
    private documentService: DocumentService,
    private productService: ProductService,
    public dialogRef: MatDialogRef<AppModalListProductKonvaComponent>,
    private toastr: ToastrService,
  ) { }
  displayedColumns: string[] = ['index', 'name', 'code', 'action'];
  selectDocumentID: any = '';
  selectProductID: any = '';
  public keyUp = new Subject<KeyboardEvent>();
  filterDocument: any = '';
  filterInputDocument: any = '';
  filterProduct: any = '';
  filterInputProduct: any = '';
  tabName: any = 'document';
  lstAllDocument: any = [];
  lstDocumentShape: any = [];
  totalDocument: any;
  pagesizeDocument: any = 10;
  pageIndexDocument: any = 1;


  lstAllProduct: any = [];
  lstProductShape: any = [];

  totalProduct: any;
  pagesizeProduct: any = 10;
  pageIndexProduct: any = 1;
  ngOnInit() {
    this.keyUp.pipe(map((event) => event), debounceTime(300)).subscribe((value) => {
      switch (true) {
        case this.tabName == 'document':
          this.filterDocument = 'name@=*' + value;
          this.getAllDocumet();
          break;
        case this.tabName == 'product':
          this.filterProduct = 'name@=*' + value;
          this.getAllProduct();
          break;
        default:
        // code block
      }
      // this.filterBrand = 'name@=*' + value;
      // this.lstLogoBrand  = [];
      // this.getLogoBrand();

      //this.ref.detectChanges();
    });
    this.getAllDocumet();
    this.getAllProduct();
    this.renderTableDocumentProduct()
  }
  saveDocumentProductShape() {
    let lstProductDocumentShape = [];
    this.lstDocumentShape.forEach(element => {
      lstProductDocumentShape.push(element)
    });
    this.lstProductShape.forEach(element => {
      lstProductDocumentShape.push(element)
    });
    this.dialogRef.close({ event: true, data: lstProductDocumentShape });
  }
  addProduct(selectProduct) {
    let productSelected = this.lstAllProduct.find(x => x.id == selectProduct);
    let indexProduct = this.lstProductShape.findIndex(x => x.product_id == selectProduct);
    if (indexProduct == -1) {
      this.lstProductShape.push({
        id: "00000000-0000-0000-0000-000000000000",
        product_id: productSelected.id,
        extend_product_code: productSelected.product_code,
        extend_product_name: productSelected.name,
      });
    }
    else {
      this.toastr.warning('', 'Sản phẩm đã được thêm')
    }

    this.lstProductShape = [...this.lstProductShape];
  }
  deleteProduct(index) {
    this.lstProductShape.splice(index, 1);
    this.lstProductShape = [... this.lstProductShape];
  }
  addDocument(selectDocument) {
    let DocumentSelected = this.lstAllDocument.find(x => x.id == selectDocument);
    let indexDocument = this.lstDocumentShape.findIndex(x => x.document_id == selectDocument);
    if (indexDocument == -1) {
      this.lstDocumentShape.push({
        id: "00000000-0000-0000-0000-000000000000",
        document_id: DocumentSelected.id,
        extend_document_code: DocumentSelected.code,
        extend_document_name: DocumentSelected.name,
      });
    }
    else {
      this.toastr.warning('', 'Tài liệu đã được thêm')
    }
    this.lstDocumentShape = [...this.lstDocumentShape];
  }
  deleteDocument(index) {
    this.lstDocumentShape.splice(index, 1);
    this.lstDocumentShape = [... this.lstDocumentShape];
  }
  renderTableDocumentProduct() {
    for (let i = 0; i < this.data.shapeRefs.length; i++) {
      if (this.data.shapeRefs[i].document_id != null) {

        this.lstDocumentShape.push(this.data.shapeRefs[i])
      }
      if (this.data.shapeRefs[i].product_id != null) {
        this.lstProductShape.push(this.data.shapeRefs[i])
      }
    }

  }
  tabClick(event) {
    switch (event.index) {
      case 0:
        this.tabName = 'document';
        break;
      case 1:
        this.tabName = 'product';
        break;
      default:
      // code block
    }
  }
  getAllDocumet() {
    this.documentService.apiDocumentsGet(this.filterDocument, '', this.pageIndexDocument, this.pagesizeDocument).subscribe(res => {
      if (res.success) {
        this.lstAllDocument = res.data.collection;
        this.lstAllDocument = [...this.lstAllDocument]
        this.pageIndexDocument = res.data.pageIndex;
        this.pagesizeDocument = res.data.pagesize;
        this.totalDocument = res.data.total;
        this.ref.detectChanges();
      }
    })
  }
  getAllProduct() {
    this.productService.apiProductsGet(this.filterProduct, '', this.pageIndexProduct, this.pagesizeProduct).subscribe(res => {
      if (res.success) {
        this.lstAllProduct = res.data.collection;
        this.lstAllProduct = [...this.lstAllProduct]
        this.pageIndexProduct = res.data.pageIndex;
        this.pagesizeProduct = res.data.pagesize;
        this.totalProduct = res.data.total;
        this.ref.detectChanges();
      }
    })
  }
  paginatorChange(event) {
    switch (true) {
      case this.tabName == 'document':
        this.pagesizeDocument = event.pageSize;
        this.pageIndexDocument = event.pageIndex + 1;
        break;
      case this.tabName == 'product':
        this.pagesizeProduct = event.pageSize;
        this.pageIndexProduct = event.pageIndex + 1;
        break;
      default:
      // code block
    }
  }
  loadMore() {
    switch (true) {
      case this.tabName == 'document':

        this.pageIndexDocument += 1;
        this.getAllDocumet();
        break;
      case this.tabName == 'product':
        this.pagesizeProduct += 1;
        this.getAllProduct();
        break;
      default:
      // code block
    }
    // this.pageLoad += 1;
    // this.selectBrandID = "";
    // this.getLogoBrand();
  }
  searchDocment(event) {

  }
}
